export default __webpack_public_path__ + "static/media/pic12.ba5dfb31.jpg";